module.exports = __webpack_public_path__ + "img/17_88.5e4862d7.png";